import { Link, useLocation } from "react-router-dom";
import Icons from "../Icons";

function Navbar() {
  let location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  return (
    <div className="fixed bg-primary-300 w-[94%] h-20  right-0 z-10 rounded-[60px] block m-auto left-0 bottom-4 max-w-[500px]">
      <div className="items flex items-center h-full w-full justify-between px-8">
        <Link to={"/report"} className="item text-center font-normal">
          <Icons
            name="report"
            stroke={isActive("/report") ? "#FF5851" : "#fff"}
            fill={isActive("/report") ? "#fff" : "none"}
            size={32}
          />
          <span className="text-xs text-white text-[10px]">گزارش</span>
        </Link>
        <Link to={"/"} className="item relative text-center font-normal">
          <Icons
            name="order"
            stroke={isActive("/") || isActive("/shipping") ? "#FF5851" : "#fff"}
            fill={isActive("/") || isActive("/shipping") ? "#fff" : "none"}
            size={32}
          />
          <span className="text-xs text-white text-[10px]">سفارش</span>
        </Link>
        <Link to={"/profile"} className="item text-center font-normal">
          <Icons
            name="show"
            stroke={isActive("/profile") ? "#FF5851" : "#fff"}
            fill={isActive("/profile") ? "#fff" : "none"}
            size={32}
          />
          <span className="text-xs text-white text-[10px]">نمایش</span>
        </Link>
      </div>
    </div>
  );
}

export default Navbar;
